// utils/checkPair.ts (或直接在组件中定义)
export function isPairInLpTokens(
  selectedTokenA,
  selectedTokenB,
  lpTokens
) {
  if (!selectedTokenA || !selectedTokenB || lpTokens.length === 0) {
    return false;
  }

  const tokenALower = selectedTokenA.toLowerCase();
  const tokenBLower = selectedTokenB.toLowerCase();
  const sortedSelected = [tokenALower, tokenBLower].sort(); // 排序以忽略顺序

  return lpTokens.some((lp) => {
    const lpALower = lp.tokenA.toLowerCase();
    const lpBLower = lp.tokenB.toLowerCase();
    const sortedLp = [lpALower, lpBLower].sort();
    return sortedLp[0] === sortedSelected[0] && sortedLp[1] === sortedSelected[1];
  });
}